export const ITEM_LINK_URL_REGEX = /((https?|ted):\/\/)|((mailto|tel):)/;
